module.exports = __webpack_public_path__ + "img/contacts_CO.b236dd3b.svg";